import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./movie_tag.css";
import { fetchMovieData } from "./movieData.js";
import { get_detail } from "../../api/getMovie.js";
import { get_movie_info } from "../../api/getMovie.js";
import { NavLink } from "react-router-dom";
import { toggleListLoading } from "../../page/DetailsPage/DetailSlice.js";
//MidAutumn
import { getDetail } from "../../page/DetailsPage/DetailSlice.js";

export const MovieTag = (props) => {
  let { isGrid, isDefaultSmall, isImage, isHoverEnable } = props;

  //Define single items or list's item
  let movieType,
    movieId,
    focusItem,
    handleMouseEnter,
    handleMouseLeave,
    movieNavPath;

  let [detailData, setDetailData] = useState(null);

  if (!props.listControl) {
    movieId = 531428;
    focusItem = 0;
    movieType = 0;
    handleMouseEnter = (id) => {
      focusItem = id;
    };
    handleMouseLeave = () => {
      focusItem = 0;
    };
    movieNavPath = "/";
  } else {
    let listControl = props.listControl;

    movieType = listControl.movieType;
    //detailData = listControl.detailData;
    movieId = listControl.movieId;
    focusItem = listControl.focusItem;
    handleMouseEnter = listControl.handleMouseEnter;
    handleMouseLeave = listControl.handleMouseLeave;
    movieNavPath = `/details/${movieType}/${movieId}`;
  }

  //Handle API Call to get CreditData
  const [creditData, setCreditData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    async function getCreditData() {
      try {
        const creditData_response = await get_movie_info(
          movieId,
          movieType == "mov" ? "getMovieCredits" : "getTvCredits"
        );
        let directorData = creditData_response.crew
          .filter((p) => p.job == "Director")
          .map((item) => item.name);
        if (directorData.length > 2) {
          setCreditData(directorData.slice(0, 2).join(", ") + " etc.");
        } else {
          setCreditData(directorData.join(", "));
        }
        setError(false);
      } catch (e) {
        setError(true);
      }
      setLoading(false);
    }

    if (props.listControl.detailData != movieId) {
      setDetailData(props.listControl.detailData);
      getCreditData();
    } else {
      dispatch(getDetail({ id: movieId, type: "mov" })).then((res) => {
        setDetailData(res.payload);
        let directorData = res.payload.credits.director.map(
          (item) => item.name
        );
        if (directorData.length > 2) {
          setCreditData(directorData.slice(0, 2).join(", ") + " etc.");
        } else {
          setCreditData(directorData.join(", "));
        }
        setLoading(false);
      });
    }
  }, [movieId]);

  //Handle Toggle and AutoFocus
  const [smallTag, setSmallTag] = useState(isDefaultSmall ? true : false);

  //Handle Toggle Btn
  function handleToggle() {
    if (smallTag == true) {
      setSmallTag(false);
    } else {
      setSmallTag(true);
    }
  }

  //Handle Focus for item
  useEffect(() => {
    if ((props.listControl != undefined) & (isHoverEnable == true)) {
      if (focusItem == movieId) {
        setSmallTag(false);
      } else {
        setSmallTag(true);
      }
    }
  }, [focusItem]);

  //Extract info

  //const id = detailData.id;
  //const title = detailData.title;
  //const posterPath = detailData.poster_path;
  //const releaseDate = detailData.release_date;
  //const overview = detailData.overview;
  //const originalLanguage = detailData.original_language;
  //const genres = detailData.genres;

  const dispatch = useDispatch();
  function handleNavLink() {
    dispatch(toggleListLoading());
  }

  if (!detailData) {
    return <div>Loading</div>;
  }

  return (
    <>
      <NavLink className="nav_link" to={movieNavPath}>
        <div
          className={`mov_tag mov_tag_container 
          ${smallTag == true ? "small_tag" : ""} 
          ${isGrid ? "grid_tag" : ""} 
          ${isImage ? "image_tag" : ""} 
          ${isHoverEnable ? "" : "hover_disable"}`}
          onMouseEnter={() => handleMouseEnter(movieId)}
          onMouseLeave={handleMouseLeave}
        >
          <div className="mov_tag img_container">
            <div
              className={`img_overlay ${
                props.listControl & isHoverEnable ? "" : "hover_disable"
              }`}
            ></div>
            <img
              className={`mov_tag main_img ${
                smallTag == true ? "small_tag" : ""
              } ${isGrid ? "grid_tag" : ""} ${isImage ? "image_tag" : ""}`}
              src={
                !isImage
                  ? detailData.poster_path
                  : detailData["backdrops"][0].file_path
              }
            />
          </div>
          <div
            className={`mov_tag info_container ${
              smallTag == true ? "small_tag" : ""
            } ${isGrid ? "grid_tag" : ""} ${isImage ? "image_tag" : ""}`}
          >
            <div className="mov_tag semi_info">
              <div className="mov_tag release_date">
                {detailData.release_date}
              </div>
              <div className="mov_tag genre">
                {detailData.genres || detailData.others?.genres}
              </div>
              <div className="mov_tag original_language">
                {detailData.original_language}
              </div>
            </div>
            <div className="mov_tag main_info">
              <div className="mov_tag director">
                {loading ? (
                  <span>Loading...</span>
                ) : error ? (
                  <span>Error: 404</span>
                ) : creditData ? (
                  creditData
                ) : (
                  ""
                )}
              </div>
              <div className="mov_tag title">{detailData.title}</div>
            </div>
            <div className="mov_tag overview">
              {detailData.overview.split(" ").length > 30 ? (
                <>
                  {detailData.overview.split(" ").slice(0, 30).join(" ")}
                  ...
                  <NavLink
                    className="nav_link"
                    to={`/details/${movieType}/${movieId}`}
                    activeclassname="active-link"
                  >
                    View More
                  </NavLink>
                </>
              ) : (
                detailData.overview
              )}
            </div>

            <div
              className={`mov_tag control_btn ${isGrid ? "grid_tag" : ""} ${
                isImage ? "image_tag" : ""
              }`}
              onClick={handleToggle}
            >
              <svg className="svg-icon" viewBox="0 0 20 20">
                <path d="M11.611,10.049l-4.76-4.873c-0.303-0.31-0.297-0.804,0.012-1.105c0.309-0.304,0.803-0.293,1.105,0.012l5.306,5.433c0.304,0.31,0.296,0.805-0.012,1.105L7.83,15.928c-0.152,0.148-0.35,0.223-0.547,0.223c-0.203,0-0.406-0.08-0.559-0.236c-0.303-0.309-0.295-0.803,0.012-1.104L11.611,10.049z"></path>
              </svg>
            </div>
          </div>
        </div>
      </NavLink>
    </>
  );
};
